import baseapi from './base-api';
import Users from './UserService';
// import UserService from './UserService';

const user= Users(baseapi);

export {
    baseapi,
    user as UserService
}